/* =====================================================================
   Annette D. — journal de l'atelier
   ---------------------------------------------------------------------
   Barre de progression de lecture des articles (sections/annetted-article).

   La barre n'est pas dans le Liquid : c'est ce script qui la crée, au
   moment où il branche ce qui la fait avancer. Sans script, il n'y a
   rien, ni barre vide ni contenu caché.

   Horizon fait défiler `.page-wrapper` et non le document sur ordinateur ;
   sur téléphone, c'est le document qui défile. On écoute donc les deux, et
   la progression se lit sur la position du corps de texte à l'écran
   (getBoundingClientRect), quel que soit le conteneur qui défile.
   ===================================================================== */

(() => {
  if (customElements.get('annetted-lecture')) return;

  class AnnettedLecture extends HTMLElement {
    connectedCallback() {
      const portee = this.closest('.shopify-section') || document;
      this.corps = portee.querySelector('[data-annetted-corps]');
      if (!this.corps) return;

      this.barre = document.createElement('div');
      this.barre.className = 'annetted-lecture-barre';
      this.barre.setAttribute('aria-hidden', 'true');
      document.body.append(this.barre);

      this.planifier = this.planifier.bind(this);
      this.conteneurs = [window, document.querySelector('.page-wrapper')].filter(Boolean);
      this.conteneurs.forEach((cible) => cible.addEventListener('scroll', this.planifier, { passive: true }));
      window.addEventListener('resize', this.planifier, { passive: true });

      this.majProgression();
    }

    disconnectedCallback() {
      this.conteneurs?.forEach((cible) => cible.removeEventListener('scroll', this.planifier));
      window.removeEventListener('resize', this.planifier);
      if (this.image) cancelAnimationFrame(this.image);
      this.barre?.remove();
      this.barre = null;
    }

    /** Une mise à jour par image, pas une par événement de défilement. */
    planifier() {
      if (this.image) return;
      this.image = requestAnimationFrame(() => {
        this.image = 0;
        this.majProgression();
      });
    }

    /** 0 quand le haut du texte atteint le haut de l'écran, 1 quand sa fin atteint le bas. */
    majProgression() {
      if (!this.barre) return;
      const zone = this.corps.getBoundingClientRect();
      const hauteur = window.innerHeight || document.documentElement.clientHeight;
      const course = zone.height - hauteur;

      let progression;
      if (course <= 0) {
        progression = zone.bottom <= hauteur ? 1 : 0;
      } else {
        progression = Math.min(1, Math.max(0, -zone.top / course));
      }
      this.barre.style.transform = `scaleX(${progression.toFixed(4)})`;
    }
  }

  customElements.define('annetted-lecture', AnnettedLecture);
})();
